import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { HoverZoomImage } from "../motion/Reveal.jsx";
import { Reveal } from "../motion/Reveal.jsx";

export default function ClubCard({ club, testId }) {
  return (
    <Reveal className="group flex h-full flex-col">
      <Link data-testid={testId} to={`/clubs/${club.id}`} className="flex h-full flex-col">
        <div className="relative overflow-hidden">
          <HoverZoomImage src={club.image} alt={`Oneiros ${club.shortName} — ${club.positioning}`} className="aspect-[4/3] w-full md:aspect-[16/11]" />
          <span className="absolute left-5 top-5 bg-navy/85 px-3 py-2 font-display text-lg leading-none text-white backdrop-blur-sm">
            {club.index}
          </span>
          {club.id === "varachha" && (
            <span className="absolute right-5 top-5 bg-brand px-3 py-2 text-[10px] font-bold uppercase tracking-[0.2em] text-white">
              New Chapter
            </span>
          )}
        </div>
        <div className="flex flex-1 flex-col gap-3 rounded-b-xl border-x border-b border-hairline p-6 transition-colors duration-300 group-hover:border-brand/40 md:p-8">
          <p className="eyebrow">{club.positioning}</p>
          <h3 className="font-display text-3xl text-navy md:text-4xl">{club.name}</h3>
          <p className="text-sm leading-relaxed text-mute md:text-base">{club.description}</p>
          <ul className="mt-2 flex flex-wrap gap-2">
            {club.highlights.slice(0, 3).map((h, i) => (
              <li
                key={h}
                data-testid={`${testId}-usp-${i}`}
                className={
                  i === 0
                    ? "flex items-center gap-1.5 border border-brand/50 bg-brand-tint px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider text-brand"
                    : "border border-hairline px-3 py-1.5 text-[11px] font-medium uppercase tracking-wider text-navy/70"
                }
              >
                {i === 0 && <Sparkles className="h-3 w-3 shrink-0" />}
                {h}
              </li>
            ))}
          </ul>
          <span className="mt-auto inline-flex items-center gap-2 pt-4 text-xs font-bold uppercase tracking-[0.2em] text-navy transition-colors duration-300 group-hover:text-brand">
            Explore Club
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </span>
        </div>
      </Link>
    </Reveal>
  );
}
